import { toFormattedDate } from 'components/DateTime';
/**
 * Extract YYYY-MM-DD from a date or datetime string (UTC-stored calendar dates).
 */
export function toCalendarDateOnly(value) {
    if (!value) {
        return null;
    }
    const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
    return match ? match[1] : null;
}
/**
 * Format deal item configuration time for FullCalendar (HH:mm, America/Montreal).
 */
export function formatConfigTimeForCalendar(value) {
    if (!value) {
        return null;
    }
    const trimmed = String(value).trim();
    if (!trimmed) {
        return null;
    }
    const plain = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(trimmed);
    if (plain) {
        return `${plain[1].padStart(2, '0')}:${plain[2]}`;
    }
    const formatted = toFormattedDate(trimmed, {
        date: false,
        time: true,
        hh: '2-digit',
        mm: '2-digit',
        timeZone: 'America/Montreal'
    });
    return (formatted === null || formatted === void 0 ? void 0 : formatted.trim()) || null;
}
/**
 * Build a local datetime string for timeGrid week/day views (no timezone offset).
 */
export function buildCalendarTimedDatetime(dateOnly, timeValue) {
    const time = formatConfigTimeForCalendar(timeValue);
    if (!time) {
        return null;
    }
    return `${dateOnly}T${time}:00`;
}
export function isProposedCalendarConfiguration(configuration) {
    return configuration.proposed === true;
}
/**
 * Resolves the sale item or package to display for a calendar configuration.
 */
export function getCalendarConfigurationDisplay(configuration) {
    var _a;
    if (configuration.type === 'PACKAGE' || configuration.package) {
        if (!configuration.package) {
            return null;
        }
        if (!configuration.startTime && !configuration.endTime) {
            return null;
        }
        return {
            id: configuration.package.id,
            title: configuration.package.title
        };
    }
    if (configuration.type !== 'OPTION') {
        return null;
    }
    if (!((_a = configuration.item) === null || _a === void 0 ? void 0 : _a.showInCalendar)) {
        return null;
    }
    return {
        id: configuration.item.id,
        title: configuration.item.title
    };
}
